export default "__VITE_ASSET__CGcU35ib__"